import { combineReducers } from 'redux';
import initializePurchase from './InitializePurchaseReducers';
import finalizePurchase from './FinalizePurchaseReducers';
import settings from './SettingsReducers';
import offerDetails from './OfferDetailsReducers';
import instapayForm from './InstapayFormReducers';
import { pageState } from 'reducers/PageStateReducers';

const rootReducer = combineReducers({
  settings,
  initializePurchase,
  finalizePurchase,
  pageState,
  offerDetails,
  instapayForm,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/payments/reducers/instapay.js